import { render, staticRenderFns } from "./SongDetails.vue?vue&type=template&id=03325298&"
import script from "./SongDetails.vue?vue&type=script&lang=js&"
export * from "./SongDetails.vue?vue&type=script&lang=js&"
import style0 from "./SongDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports